import { render } from "./allpayments.vue?vue&type=template&id=6193fb5c&scoped=true"
import script from "./allpayments.vue?vue&type=script&lang=js"
export * from "./allpayments.vue?vue&type=script&lang=js"

import "./allpayments.vue?vue&type=style&index=0&id=6193fb5c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6193fb5c"]])

export default __exports__